export const PROFILE_REQUEST = 'PROFILE_REQUEST';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const PROFILE_FAILED = 'PROFILE_FAILED';
export const SINGLE_PROFILE_SUCCESS = 'SINGLE_PROFILE_SUCCESS';
export const SINGLE_PROFILE_FAILED = 'SINGLE_PROFILE_SUCCESS';